// extracted by mini-css-extract-plugin
module.exports = {"Display":"Display_Display__3iHrE","Output":"Display_Output__2sGbc"};